import {
  MessageResponseDto,
  GetCampaignDto,
  CreateCampaignDto,
  EditCampaignDto,
  CampaignControllerGet200Response,
  CampaignApiFp,
  DeleteCampaignDto,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseCampaignModel = CampaignControllerGet200Response;
export type GetCampaignModel = GetCampaignDto;
export type MutateResponseCampaignModel = MessageResponseDto;
export type CreateCampaignModel = CreateCampaignDto;
export type UpdateCampaignModel = EditCampaignDto;
export type DeleteCampaignModel = DeleteCampaignDto;

export interface CreateCampaignModelExtension {
  campaign: CreateCampaignModel;
  file: File;
}

export interface UpdateCampaignModelExtension {
  campaign: UpdateCampaignModel;
  file: File;
}

export const apiCampaignFp = CampaignApiFp(apiConfig);
export const getCampaignController = apiCampaignFp.campaignControllerGet;
export const createCampaignController = apiCampaignFp.campaignControllerCreate;
export const updateCampaignController = apiCampaignFp.campaignControllerEdit;
export const deleteCampaignController = apiCampaignFp.campaignControllerDelete;

export const QueryKeyCampaign = QueryKey.Campaign;
